'use client'

import { useParams } from "next/navigation";
import { getPhotographer } from "../../../app/lib/prisma-db.js";

export default function Page(){
    const id = useParams().slug.split("-", 1);
    const photographer = getPhotographer(id);

    return(
        <>
        </>
    )
}

